import React from 'react';
import { Box, Button } from '@mui/material';

import { LiveEvent } from '@/types';

import { MONEYLINE_TEAM1_COLOR, MONEYLINE_TEAM2_COLOR } from '@/constants';

interface LiveEventCardMobileMoneylineProps {
  event: LiveEvent;
  onTeamClick: (event: LiveEvent, index: 1 | 2) => void;
}

export function LiveEventCardMobileMoneyline({
  event,
  onTeamClick,
}: LiveEventCardMobileMoneylineProps) {
  function getLabel(index: 1 | 2) {
    const player = index === 1 ? event.player1 : event.player2;
    const team = index === 1 ? event.team1 : event.team2;
    const price = index === 1 ? event.price1 : event.price2;

    if (player?.shortName) return `${player.shortName.toUpperCase()} ${price}`;
    if (team?.abbr) return `${team.abbr.toUpperCase()} ${price}`;
    if (player?.name) {
      const lastName = player.name.split(' ').pop() || player.name;
      return `${lastName.toUpperCase()} ${price}`;
    }
    return `TEAM ${index} ${price}`;
  }

  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
        gap: 1,
        mt: 0.5,
      }}
    >
      <Button
        onClick={(e) => {
          e.stopPropagation();
          onTeamClick(event, 1);
        }}
        variant="contained"
        fullWidth
        sx={{
          bgcolor: MONEYLINE_TEAM1_COLOR,
          color: 'common.white',
          fontWeight: 700,
          fontSize: '0.875rem',
          py: 1.5,
          px: 3,
          minWidth: 120,
          borderRadius: '8px',
          textTransform: 'none',
          boxShadow: (theme) => `0 5px 0 ${theme.palette.primary.dark}`,
          '&:hover': {
            bgcolor: 'primary.dark',
            boxShadow: (theme) => `0 4px 0 ${theme.palette.primary.dark}`,
          },
        }}
      >
        {getLabel(1)}
      </Button>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          onTeamClick(event, 2);
        }}
        variant="contained"
        fullWidth
        sx={{
          bgcolor: MONEYLINE_TEAM2_COLOR,
          color: 'common.white',
          fontWeight: 700,
          fontSize: '0.875rem',
          py: 1.5,
          px: 3,
          minWidth: 120,
          borderRadius: '8px',
          textTransform: 'none',
          boxShadow: (theme) => `0 5px 0 ${theme.palette.secondary.dark}`,
          '&:hover': {
            bgcolor: 'secondary.dark',
            boxShadow: (theme) => `0 4px 0 ${theme.palette.secondary.dark}`,
          },
        }}
      >
        {getLabel(2)}
      </Button>
    </Box>
  );
}
